import React, { useState, useEffect } from 'react';
import { Dialog, DialogProps } from '@material-ui/core';
import ReactPlayer from 'react-player';

interface VideoPlayerModalProps {
  modalProps:DialogProps,
  url: string
}

const VideoPlayerModal: React.FC<VideoPlayerModalProps> = ({ modalProps, url }) => {
  const { open, onClose } = modalProps;
  const [isPlaying, setIsPlaying] = useState(false);

  useEffect(() => {
    if (open) {
      setIsPlaying(true);
    } else {
      setIsPlaying(false);
    }
  }, [open]);

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth='md'
    >
      <ReactPlayer
        style={{ overflow: 'hidden' }}
        playing={isPlaying}
        controls
        url={url}
        config={{
          youtube: {
            embedOptions: {
              height: '100%',
              width: '100%'
            },
            playerVars: {
              modestbranding: 1
            }
          },
          vimeo: {
            playerOptions: {
              height: '100%x',
              width: '100%',
              maxwidth: '100%'
            }
          }
        }}
      />
    </Dialog>
  );
};

export default VideoPlayerModal;
